<div class="text-center">
  <h1>Página no disponible</h1>
  <p class="mb-1">El enlace utilizado no es válido o ha expirado.</p>
  <p class="mb-0">
    Por favor, vuelve al sitio principal e intenta acceder nuevamente.
  </p>
</div>
